import { FieldBlockType } from "app/main/pages/general-editor-tabs/content-tab/content-tab.dto";

export interface BlockTypeDto {
  type: FieldBlockType;
  class: string;
  name: string;
}

const blockTypes: Array<BlockTypeDto> = [
  {
    type: FieldBlockType.ContentBox,
    class: "content-editor-block",
    name: "content box",
  },
  {
    type: FieldBlockType.PageBreak,
    class: "page-break-block",
    name: "page-break",
  },
  {
    type: FieldBlockType.UploadPdf,
    class: "upload-pdf-block",
    name: "upload-pdf-block",
  },
  {
    type: FieldBlockType.ProductTable,
    class: "product-table-block",
    name: "product-table",
  },
  {
    type: FieldBlockType.AddAttachment,
    class: "attachment-block",
    name: "attachment",
  },
  {
    type: FieldBlockType.ImageBlock,
    class: "image-block",
    name: "image",
  },
  {
    type: FieldBlockType.FormBuilder,
    class: "form-builder-block",
    name: "form",
  },
  {
    type: FieldBlockType.Table,
    class: "table-builder-block",
    name: "table",
  },
  {
    type: FieldBlockType.ContentFields,
    class: "content-field-block",
    name: "text block",
  },
  {
    type: FieldBlockType.ContentFields,
    class: "content-field-block",
    name: "checkbox block",
  },
  {
    type: FieldBlockType.ContentFields,
    class: "content-field-block",
    name: "droplist block",
  },
  {
    type: FieldBlockType.ContentFields,
    class: "content-field-block",
    name: "multichoice block",
  },
  {
    type: FieldBlockType.ContentFields,
    class: "content-field-block",
    name: "datepicker block",
  },
  {
    type: FieldBlockType.ContentFields,
    class: "content-field-block",
    name: "signature block",
  },
];

export function findBlockType(name: string): BlockTypeDto | undefined {
  return blockTypes.find((type) => type.name === name);
}
